export default __webpack_public_path__ + "static/media/icon-visibility-color-gray.22153b55.svg";